import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    minWidth: 600,
    maxWidth: 800,
    borderRadius: "calc(12px * var(--app-radius-scale, 1))",
    backgroundColor: "var(--color-background-paper)",
    backgroundImage: "none",
  },
  formContainer: {
    padding: theme.spacing(1),
    backgroundColor: "var(--color-background-default)",
    maxHeight: "65vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      background: "var(--color-background-paper)",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "var(--color-divider)",
      borderRadius: "3px",
      "&:hover": {
        background: "var(--color-text-secondary)",
      },
    },
  },
  sectionLabel: {
    fontSize: "0.7rem",
    fontWeight: 700,
    color: "var(--color-text-secondary)",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    marginTop: theme.spacing(0.75),
    marginBottom: theme.spacing(0.5),
    display: "block",
  },
  sectionCard: {
    backgroundColor: "var(--color-background-paper)",
    padding: theme.spacing(0.875),
    borderRadius: "calc(8px * var(--app-radius-scale, 1))",
    border: "1px solid var(--color-divider)",
    marginBottom: theme.spacing(1),
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: "var(--color-primary-text)",
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    },
  },
  formField: {
    marginBottom: 0,
    "& .MuiOutlinedInput-root": {
      backgroundColor: "var(--color-background-default)",
      transition: "all 0.2s ease",
      "&:hover": {
        borderColor: "var(--color-primary-text)",
      },
      "&.Mui-focused": {
        borderColor: "var(--color-primary-text)",
        boxShadow: "0 0 0 2px rgba(var(--color-primary-rgb), 0.1)",
      },
    },
    "& .MuiOutlinedInput-input::placeholder": {
      color: "var(--color-text-secondary)",
      opacity: 0.6,
    },
    "& .MuiFormHelperText-root": {
      marginTop: "4px",
      fontSize: "0.7rem",
    },
    "& .MuiInputBase-input": {
      color: "var(--color-text-primary)",
    },
    "& .MuiInputLabel-root": {
      color: "var(--color-text-secondary)",
      fontSize: "0.9rem",
      "&.Mui-focused": {
        color: "var(--color-text-primary)",
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--color-divider)",
    },
  },
  errorText: {
    fontSize: "0.75rem",
    color: "var(--color-error)",
    fontWeight: 600,
    marginTop: theme.spacing(0.5),
  },
  dialogHeader: {
    borderBottom: "1px solid var(--color-divider)",
    padding: theme.spacing(1),
    background: "linear-gradient(135deg, var(--color-background-paper) 0%, var(--color-background-default) 100%)",
  },
  dialogTitle: {
    fontSize: "1.1rem",
    fontWeight: 700,
    color: "var(--color-text-primary)",
    margin: 0,
    letterSpacing: "-0.01em",
  },
  dialogFooter: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(0.75),
    padding: theme.spacing(0.75, 1),
    borderTop: "1px solid var(--color-divider)",
    backgroundColor: "var(--color-background-paper)",
  },
  feeSection: {
    backgroundColor: "var(--color-background-default)",
    padding: theme.spacing(0.75),
    borderRadius: "calc(6px * var(--app-radius-scale, 1))",
    marginBottom: theme.spacing(0.75),
    border: "1px solid var(--color-divider)",
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: "var(--color-primary-text)",
      backgroundColor: "var(--color-background-paper)",
    },
  },
  feeSectionTitle: {
    fontSize: "0.7rem",
    fontWeight: 600,
    color: "var(--color-text-secondary)",
    marginBottom: theme.spacing(0.5),
    display: "block",
    textTransform: "capitalize",
  },
  gridSpacing: {
    marginBottom: 0,
  },
  submitBtn: {
    minWidth: 90,
    background: "linear-gradient(135deg, var(--color-primary-text) 0%, var(--color-primary-text) 100%)",
    fontWeight: 600,
    fontSize: "0.8rem",
  },
  cancelBtn: {
    minWidth: 75,
    fontWeight: 600,
    fontSize: "0.8rem",
  },
  loadingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(3),
  },
  amountInput: {},
}));

export default useStyles;
